import { useCallback, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Alert,
    Typography,
} from "@mui/material";
import { Localized } from "@fluent/react";
import { completeCommentingTask, UrsOffer } from "../ursOfferSlice";
import { useAppDispatch } from "../../../app/hooks";
import { showError, showSuccess } from "../../notifications/notificationsSlice";
import { YesButton } from "../../../app/components/YesButton";
import { CancelButton } from "../../../app/components/CancelButton";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded"

interface UrsOfferCompleteCommentingDialogProps {
    ursOfferId: string;
    onSave: (entity: UrsOffer) => void;
    onCancel: () => void;
}

export const UrsOfferCompleteCommentingDialog: React.FC<UrsOfferCompleteCommentingDialogProps> = ({
    ursOfferId,
    onSave,
    onCancel
}) => {

    const dispatch = useAppDispatch()
    const [saving, setSaving] = useState<boolean>(false)
    const [serverError, setServerError] = useState("")

    const handleConfirmCompleteCommentingClick = async () => {
        setSaving(true)

        try {
            const result = await dispatch(completeCommentingTask(ursOfferId))
            if (completeCommentingTask.fulfilled.match(result)) {
                const updatedEntity = result.payload as UrsOffer;
                dispatch(showSuccess("saved"))
                onSave(updatedEntity)
            } else {
                let errorMsg = "error"
                if (result.payload && result.payload.kind === 'http') {
                    const problem = result.payload.problem
                    if (problem) {
                        errorMsg = problem.title

                    }
                }
                setServerError(errorMsg)
            }

        } catch (error) {
            dispatch(showError("error"))
        }
        finally {
            setSaving(false)
        }
    }


    const handleCancelClick = useCallback(() => {
        onCancel();
    }, [])

    return (
        <Dialog open={true} maxWidth="xs">
            <DialogTitle
                component="div"
                sx={(t) => ({
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    pr: 6,
                    py: 1,
                    bgcolor: t.palette.mode === "light" ? t.palette.grey[100] : t.palette.grey[900],
                    borderBottom: `1px solid ${t.palette.divider}`,
                })}
            >
                <Typography variant="subtitle1" fontWeight={600}>
                    <Localized id="urs-offer-action-comment-requirement-task">
                        <span>Zakończyć komentowanie?</span>
                    </Localized>
                </Typography>
            </DialogTitle>

            <DialogContent dividers sx={{ pt: 1.5 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: serverError ? 1.5 : 0.5 }}>
                    <Localized id="urs-offer-action-comment-requirement-task-info">
                        <span>_warning</span>
                    </Localized>
                </Typography>

                {serverError && (
                    <Alert
                        severity="error"
                        icon={<ErrorOutlineRoundedIcon />}
                        onClose={() => setServerError("")}
                        sx={{ mt: 1 }}
                    >
                        <Localized id={serverError}>
                            <span>Wystąpił błąd serwera</span>
                        </Localized>
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <YesButton loading={saving} onClick={handleConfirmCompleteCommentingClick} />
                <CancelButton loading={saving} onClick={handleCancelClick} />
            </DialogActions>
        </Dialog>
    );
};

